import useSWR from 'hooks/useSWR';
import { VideoListDTO } from 'types/company';
import { useSWRResource } from 'util/resource/useSWRResource';
import { companiesAPIUrls } from './companiesApi';

export function useVideos(companyId: number) {
  const swrResult = useSWR<VideoListDTO>(companiesAPIUrls.videos.list(companyId));
  return useSWRResource(swrResult);
}
